<canvas id="tutorial" [width]="canvasRender[0]" [height]="canvasRender[1]"></canvas>